import { useState, useEffect } from 'react';
import { IconButton, Menu, MenuItem, Tooltip, useMediaQuery } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import
{
  StyledToggleButtonGroup,
  StyledToggleButton,
  TitleContainer,
  Title,
  StatsContainer,
  PlayerStatsContainer,
  SingleStatContainer,
  PlayerColor,
  PlayerScore,
  WorldScore
} from './ViewStatsBurger.styles';
import { routes } from '../../../options/routes';

const ViewStatsBurger = (props) =>
{
  // Dynamically set orientation based on breakpoint

  const [anchorEl, setAnchorEl] = useState(null);

  const handleViewStatsClick = (event) =>
  {
    setAnchorEl(event.currentTarget);
  };

  const handleViewStatsClose = (event, type) =>
  {
    setAnchorEl(null);
  };

  const handleIndexStatsSelect = (event, type) =>
  {
    setAnchorEl(null);
    window.location = `${routes.indexStats}/${props.playerId}`;
  };

  const handleDrillStatsSelect = (event, type) =>
  {
    setAnchorEl(null);
    window.location = `${routes.indexDrillStats}/${props.playerId}`;

  };
  return (
    <>
      <Tooltip title="View Stats">
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={Boolean(anchorEl) ? 'long-menu' : undefined}
          aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
          aria-haspopup="true"
          onClick={(event) => handleViewStatsClick(event, "stuff")}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleViewStatsClose}
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
      >
        <MenuItem onClick={handleIndexStatsSelect}>View Index Stats</MenuItem>
        <MenuItem onClick={handleDrillStatsSelect}>View Drills Stats</MenuItem>
      </Menu></>
  );
}

export default ViewStatsBurger;
